import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tag, Tooltip } from 'antd';
import { ForkOutlined } from '@ant-design/icons';

import messages from './messages';

// const getTitle = (dep) => {
//   if (!dep.content) { return ''; }
//   if (dep.content.question) { return dep.content.question.title; }
//   if (dep.content.block) { return dep.content.block.title; }
//   if (dep.content.text) { return dep.content.text.title; }
//   return '';
// };

const DependenciesTooltip = ({ dependencies, dependencyOperator }) => (
  <>
    <p><FormattedMessage {...messages.dependenciesTitle} /></p>
    {dependencies.map((dep, i) => (
      <div key={dep.id}>
        <p>{dep.question.title}</p>
        <em>is answered with</em>
        <ul>
          {dep.options.map(o => <li key={o.id}>{o.title}</li>)}
          {dep.answer && (
            <li>{dep.answer}</li>
          )}
        </ul>
        {i < dependencies.length - 1 && (
        <p style={{ margin: '1em 0' }}>
          <em>{ dependencyOperator }</em>
        </p>
        )}
      </div>
    ))}
  </>
);

// const DependantsTooltip = ({ dependants }) => (
//   <>
//     <p><FormattedMessage {...messages.dependantsTitle} /></p>
//     <ul>
//       {dependants.map(dep => (
//         <li key={dep.id}>
//           {getTitle(dep)}
//         </li>
//       ))}
//     </ul>
//   </>
// );

const Dependencies = ({ dependencies = [], dependencyOperator }) => (
  <>
    {dependencies.length > 0 && (
    <Tooltip title={<DependenciesTooltip dependencies={dependencies} dependencyOperator={dependencyOperator} />}>
      <Tag icon={<ForkOutlined />}>
        Follow up
      </Tag>
    </Tooltip>
    )}
    {/* {dependants.length > 0 && (
    <Tooltip title={<DependantsTooltip dependants={dependants} />}>
      {dependants.map(dependency => (
        <NodeExpandOutlined
          key={dependency.id}
          rotate={90}
          style={{ color: getDependencyColor(dependency.id) }}
        />
      ))}
    </Tooltip>
    )} */}
  </>
);

export default Dependencies;
